import styled from 'styled-components'

export const ActionsContainer = styled.div`
  margin-top: 24px;
`

export const Header = styled.div`
  & > p:first-child {
    color: ${props => props.theme.colors.grey.tone700};
    margin: 0;
    margin-bottom: ${props => props.theme.whiteLabel.spacing.sp16};
    font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
    font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
    letter-spacing: ${props => props.theme.texts.bodyMRegular.letterSpacing};
  }
`
